export const environment = {
  production: false,
  apiUrl: 'https://backend.capitoltrades-coll.staging.eu-central-1.master.2iq.cloud',
  oauthProviderUrl: 'https://2iq-staging.auth.eu-central-1.amazoncognito.com/oauth2/authorize',
  clientId: '1nijq662adubm58fo0umg4dt0',
  userInfo: 'https://2iq-staging.auth.eu-central-1.amazoncognito.com/oauth2/userInfo'
};
